import React, { useEffect } from 'react';
import styled from 'App/styled';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { Link } from 'react-router-dom';
import { BreadCrumb } from 'store/app/types';
import { filterUrl } from 'helpers/breadcrumb';
import { pushData } from '@nykaa/data-layer';

const Wrapper = styled.ul`
  display: flex;
  list-style: none;
  padding: 10px 0;
`;

const List = styled.li`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #888888;
  ${({ theme }) => theme.typography.subTitleMedium};
  &.last-list {
    .name {
      pointer-events: none;
    }
  }
  .arrow {
    ${({ theme }) => theme.typography.bodyXSmall};
  }
  .name {
    color: #888888;
    padding: 0 5px;
    text-decoration: initial;
  }
`;

interface BreadCrumbProps {
  data?: BreadCrumb[];
}

const BreadCrumbComponent = ({ data }: BreadCrumbProps) => {
  let breadCrumb = useSelector((state: State) => state.appReducer.breadCrumb);
  const getUrl = (value: string) => filterUrl(value);
  if (data) {
    breadCrumb = data;
  }

  useEffect(() => {
    pushData({ breadcrumb: breadCrumb });
  }, [breadCrumb]);

  return (
    <nav aria-label="Breadcrumb">
      <Wrapper>
        {breadCrumb?.map((crumb: BreadCrumb, idx) => {
          const url = getUrl(crumb.value);
          const isLast = idx === breadCrumb.length - 1;
          const lastClass = isLast ? 'last-list' : '';
          return (
            <List
              key={crumb.key}
              className={lastClass}
              {...(isLast && { 'aria-current': 'page' })}
            >
              <Link
                to={url}
                className="name"
              >
                {crumb.key}
              </Link>
              {!isLast && <span className="arrow">❯</span>}
            </List>
          );
        })}
      </Wrapper>
    </nav>
  );
};

export default BreadCrumbComponent;
